function initReviewsSlider () {
  const reviewsSlider = document.querySelector('.reviews-slider');

  if (!reviewsSlider) return;

  const { sectionId } = reviewsSlider.dataset;

  new Swiper(reviewsSlider, {
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: false,
    pagination: {
      el: `.swiper-pagination--${sectionId}`,
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30
      }
    }
  });
}

initReviewsSlider();